import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classnames from 'classnames';
import queryString from 'query-string';
import {
    Col,
    Row
} from 'react-bootstrap';

import {
    settingsApproveEmailChange,
} from '../../actions/SettingsActions';

const mapStateToProps = (state) => ({
    ...state.settingsReducer,
    primaryEmail: state.meReducer.me.primaryEmail,
    event: state.eventReducer.event,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    settingsApproveEmailChange
}, dispatch);

class MainApproveChangeEmailContainerView extends Component {

    constructor() {
        super();
        this.state = {
            approvingFailed: false
        };
    }

    componentDidMount() {
        const {token, userId, next} = queryString.parse(this.props.location.search);
        const error = () => {
            this.setState({approvingFailed: true});
        };
        const success = () => {
            window.location = next + '/settings/profile';
        };

        this.props.settingsApproveEmailChange({token, userId, error, success});
    }

    render() {
        const {token, userId} = queryString.parse(this.props.location.search);
        const {approvingFailed} = this.state;
        const text = token && userId && !approvingFailed ? 'approving your email request ...' : 'something went wrong';
        const imageName = approvingFailed ? '/images/change_email/reject.png' : '/images/change_email/approve.png';
        return (
            <div className="change-email-container container text-center">
                <Row>
                    <Col xs={12}>
                        <h1><strong>Change Email</strong></h1>
                        <h4 className="margin-top-small">{text}</h4>
                        <img className="change-email-image" src={imageName}/>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainApproveChangeEmailContainerView);
